import React from "react";
import { CustomView, isBrowser, isTablet } from "react-device-detect";

export default function BrowserView({ children, ...props }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CustomView condition={isBrowser && !isTablet} {...props}>
      {children}
    </CustomView>
  );
}
